import React, { useState } from "react";
import emailjs from "@emailjs/browser";

// Shown once after a code run; emails the response to the team via EmailJS.

export default function FeedbackPopup({ open, closePopup }) {
  const [rating, setRating] = useState("");
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    if (!rating) {
      setStatus("Please select Yes or No.");
      return;
    }

    setStatus("Sending...");

    // EmailJS rejects the template unless the email field is a valid address.
    const storedEmail = sessionStorage.getItem("userEmail") || "";
    const templateParams = {
      name: sessionStorage.getItem("userName") || "Anonymous",
      email: storedEmail.includes("@") ? storedEmail : "feedback@deebug.app",
      title: "DEEBug User Feedback",
      subject: "DEEBug User Feedback",
      message: `Did you find DEEBug easy and helpful? ${rating}\n\nComments: ${message || "None"}`,
    };

    // Same EmailJS service/template as the Contact page.
    emailjs
      .send("service_e49oba1", "template_mcjpjkr", templateParams, { publicKey: "luuvKW7WoulQb4MP_" })
      .then(() => {
        setStatus("Thank you for your feedback!");

        // Delay the close so the thank-you is readable.
        setTimeout(() => {
          closePopup();
          setRating("");
          setMessage("");
          setStatus("");
        }, 1500);
      })
      .catch(() => {
        setStatus("Failed to send. Please try again.");
      });
  };

  return (
    <div style={{ position: "fixed", bottom: "24px", right: "24px", width: "320px", maxWidth: "calc(100vw - 48px)", zIndex: 9999 }}>
      <div style={{ padding: "20px", backgroundColor: "#fff", borderRadius: "14px", boxShadow: "0 8px 32px rgba(0,0,0,0.15)", fontFamily: "Manrope, sans-serif", borderTop: "4px solid #0EA5E9" }}>
        <h2 style={{ fontSize: "1.25em", fontWeight: "700", marginBottom: "4px", color: "#0F172A" }}>
          Did you find DEEBug easy and helpful?
        </h2>
        <p style={{ fontSize: "0.85em", color: "#64748b", marginBottom: "20px" }}>Your feedback helps us improve.</p>

        <div style={{ display: "flex", gap: "12px", marginBottom: "20px" }}>
          <button
            onClick={() => setRating("Yes")}
            style={{
              padding: "10px 24px",
              backgroundColor: rating === "Yes" ? "#22c55e" : "#f1f5f9",
              color: rating === "Yes" ? "#fff" : "#334155",
              border: rating === "Yes" ? "2px solid #22c55e" : "2px solid #e2e8f0",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "0.9em",
            }}
          >
            👍 Yes
          </button>
          <button
            onClick={() => setRating("No")}
            style={{
              padding: "10px 24px",
              backgroundColor: rating === "No" ? "#ef4444" : "#f1f5f9",
              color: rating === "No" ? "#fff" : "#334155",
              border: rating === "No" ? "2px solid #ef4444" : "2px solid #e2e8f0",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "0.9em",
            }}
          >
            👎 No
          </button>
        </div>

        <label style={{ display: "block", marginBottom: "8px", fontWeight: "600", fontSize: "0.9em", color: "#334155" }}>
          Any comments? <span style={{ fontWeight: "400", color: "#94a3b8" }}>(optional)</span>
        </label>
        <textarea
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Tell us what you think..."
          style={{
            width: "100%",
            padding: "10px 12px",
            borderRadius: "10px",
            border: "1.5px solid #e2e8f0",
            marginBottom: "16px",
            resize: "vertical",
            fontSize: "0.9em",
            color: "#334155",
            boxSizing: "border-box",
          }}
        />

        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <button
            onClick={handleSubmit}
            style={{
              padding: "10px 20px",
              backgroundColor: "#0EA5E9",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "0.9em",
            }}
          >
            Submit
          </button>
          <button
            onClick={closePopup}
            style={{
              padding: "10px 20px",
              backgroundColor: "#f1f5f9",
              color: "#334155",
              border: "2px solid #e2e8f0",
              borderRadius: "10px",
              cursor: "pointer",
              fontSize: "0.9em",
            }}
          >
            Skip
          </button>
          <span style={{ fontSize: "0.82em", color: status.startsWith("Thank") ? "#22c55e" : "#ef4444" }}>{status}</span>
        </div>
      </div>
    </div>
  );
}
